import {
  Body,
  FocusWrapper,
  styled,
  useIsDarkMode,
} from "@kivra/react-components";
import type { StrongAuthService as StrongAuthServiceType } from "../../utils/teliaTunnistus";

interface StrongAuthServiceProps extends StrongAuthServiceType {
  clickedService?: string;
  setClickedService(id: string): void;
  strongAuthClick(): void;
}

export const StrongAuthService: React.FC<StrongAuthServiceProps> = ({
  clickedService,
  setClickedService,
  logo,
  logo2x,
  logo3x,
  logo4x,
  name,
  strongAuthClick,
  id,
}) => {
  const isDarkMode = useIsDarkMode();
  const isDisabled = Boolean(clickedService);
  const isClicked = clickedService === id;
  return (
    <ServiceContainer
      onClick={() => {
        if (!isDisabled) {
          strongAuthClick();
          setClickedService(id);
        }
      }}
      role="link"
      aria-label={name}
      isDarkMode={isDarkMode}
      isDisabled={isDisabled}
      isClicked={isClicked}
    >
      <LogoContainer>
        <img
          src={`/assets/${logo}`}
          srcSet={`
    /assets/${logo4x} 4x,
    /assets/${logo3x} 3x,
    /assets/${logo2x} 2x,
    /assets/${logo} 1x
  `}
          alt={name}
          width={64}
          height={64}
        />
      </LogoContainer>
      <BodyXS size="small">{name}</BodyXS>
    </ServiceContainer>
  );
};

const ServiceContainer = styled(FocusWrapper)<{
  isDarkMode: boolean;
  isDisabled: boolean;
  isClicked: boolean;
}>(({ isDarkMode, isDisabled, isClicked }) => ({
  height: "109px",
  width: "109px",
  borderRadius: "$radius-medium",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-evenly",
  border: isDarkMode ? "none" : "1px solid",
  borderColor: "$border-distinct",
  backgroundColor: "$background-secondary",
  cursor: "pointer",
  "&:hover": {
    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.08)",
    transform: "translate3d(0, -2px, 0)",
  },
  "& > p": {
    borderBottom: "1px solid transparent",
    transition: "all 0.2s ease-in-out",
  },
  "&:hover > p": {
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    borderBottomColor: "$text-primary",
  },
  transition: "all 0.25s cubic-bezier(0.35, 0.35, 0.58, 1)",
  opacity: isDisabled ? 0.7 : 1,
  filter: isDisabled && !isClicked ? "grayscale(1)" : "grayscale(0)",
}));

const LogoContainer = styled.div({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "$radius-large",
  width: 72,
  height: 72,
  backgroundColor: "!!$white",
});

const BodyXS = styled(Body)({
  fontWeight: 400,
  fontSize: `${12 / 16}rem`,
  lineHeight: `${16 / 16}rem`,
});
